import { imageUrl } from '@helpers/image';
import * as React from 'react';
import S from './Accreditations.styles';
const Accreditations = ({ size = 'small', loading = 'lazy', ...props }) => {
    return (React.createElement(S.Container, { "data-size": size },
        React.createElement(S.List, null, props.items.map(renderItem))));
    function renderItem(item) {
        if (item.url) {
            return (React.createElement(S.Item, { key: item.src },
                React.createElement(S.Link, { href: item.url, target: item.target, "data-dark-bg": item.darkBackground ?? false },
                    React.createElement(S.LogoWrapper, null,
                        React.createElement(S.Logo, { alt: item.altText, loading: loading, role: item.altText ? undefined : 'presentation', src: imageUrl(item, { width: 153, heightratio: 138 / 153 }), width: "100%", height: "138" })))));
        }
        return (React.createElement(S.Item, { key: item.src },
            React.createElement(S.Link, { as: "span", "data-dark-bg": item.darkBackground ?? false },
                React.createElement(S.LogoWrapper, null,
                    React.createElement(S.Logo, { alt: item.altText, loading: loading, role: item.altText ? undefined : 'presentation', src: imageUrl(item, { width: 153, heightratio: 138 / 153 }), width: "100%", height: "138" })))));
    }
};
export default Accreditations;
